import * as React from 'react';
import { makeContextModule } from '@cian/react-utils';

import { EMessageType } from '../../types/messageType';
import { TMessage, TOutcomingStatus } from '../../types/messages';
import { EUserColor } from '../../types/userName';

export interface IMessageContextValue {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
  chatId: string;
  messageType: EMessageType;
  isLastInChain: boolean;
  isFirstUserPhrase: boolean;
  messageRef: React.RefObject<HTMLDivElement | null>;
  highlighted: boolean;
  userColor: EUserColor;
  cancelLongPress: VoidFunction;
  onHighlightEnd: VoidFunction;
}

export const { Context: MessageContext, useContext: useMessageContext } = makeContextModule<IMessageContextValue>({
  contextName: 'MessageContext',
});
